(() => {
  const money = (cents) => {
    const currency = window.SNTD?.currency || 'USD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format((cents || 0) / 100);
  };

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character]));

  document.querySelectorAll('[data-card-view-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const media = button.closest('[data-product-card-media]');
      if (!media) return;
      const showingBack = media.classList.toggle('is-showing-secondary');
      button.setAttribute('aria-pressed', String(showingBack));
      button.setAttribute('aria-label', showingBack ? 'View front product image' : 'View back product image');
      const label = button.querySelector('[data-card-view-label]');
      if (label) label.textContent = showingBack ? 'VIEW FRONT' : 'VIEW BACK';
    });
  });

  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('menu-open', open);
    });
    mobileMenu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
      mobileMenu.classList.remove('is-open');
      menuToggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
    }));
  }

  const drawer = document.querySelector('[data-cart-drawer]');
  const openDrawer = () => {
    if (!drawer) return;
    drawer.showModal();
    document.body.classList.add('drawer-open');
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.close();
    document.body.classList.remove('drawer-open');
  };
  document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', openDrawer));
  document.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', closeDrawer));
  drawer?.addEventListener('click', (event) => { if (event.target === drawer) closeDrawer(); });

  const renderCart = (cart) => {
    document.querySelectorAll('[data-cart-count], [data-cart-drawer-count]').forEach((node) => { node.textContent = cart.item_count; });
    document.querySelectorAll('[data-cart-subtotal]').forEach((node) => { node.textContent = money(cart.total_price); });
    const items = document.querySelector('[data-cart-items]');
    if (!items) return;
    if (!cart.items.length) {
      items.innerHTML = '<p class="prototype-note">Your cart is empty.</p>';
      return;
    }
    items.innerHTML = cart.items.map((item) => {
      const image = item.featured_image?.url ? `<img src="${escapeHtml(item.featured_image.url)}" alt="${escapeHtml(item.product_title)}" width="80" height="80">` : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      return `<article class="drawer-item">${image}<div><h3>${escapeHtml(item.product_title)}</h3><p>${escapeHtml(variant)} × ${item.quantity}</p><p>${money(item.final_line_price)}</p></div></article>`;
    }).join('');
  };

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const json = root.querySelector('[data-product-variants]');
    if (!json) return;
    let variants;
    try {
      variants = JSON.parse(json.textContent);
    } catch (error) {
      return;
    }
    const optionGroups = [...root.querySelectorAll('[data-option-group]')];
    const selected = optionGroups.map((group) => group.querySelector('.is-selected')?.dataset.optionValue || group.querySelector('[data-option-button]')?.dataset.optionValue);
    const variantInput = root.querySelector('[data-variant-input]');
    const price = root.querySelector('[data-product-price]');
    const addButton = root.querySelector('[data-add-to-cart]');
    const addText = root.querySelector('[data-add-to-cart-text]');

    const update = () => {
      const variant = variants.find((candidate) => candidate.options.every((option, index) => option === selected[index]));
      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addText) addText.textContent = 'Unavailable';
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = money(variant.price);
      if (addButton) addButton.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (location.pathname.includes('/products/')) history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
    };

    root.querySelectorAll('[data-option-button]').forEach((button) => button.addEventListener('click', () => {
      const index = Number(button.dataset.optionIndex);
      selected[index] = button.dataset.optionValue;
      const group = button.closest('[data-option-group]');
      group.querySelectorAll('[data-option-button]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-selected', active);
        item.setAttribute('aria-pressed', String(active));
      });
      update();
    }));
    update();
  });

  if (window.SNTD?.cartDrawer) {
    document.querySelectorAll('.product-form').forEach((form) => form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const root = form.closest('[data-product-root]');
      const error = root?.querySelector('[data-product-error]');
      const submit = form.querySelector('[data-add-to-cart]');
      try {
        if (submit) submit.disabled = true;
        const response = await fetch(window.SNTD.routes.cartAdd, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error((await response.json()).description || 'Unable to add this product.');
        const cart = await fetch(window.SNTD.routes.cartJson, { headers: { Accept: 'application/json' } }).then((result) => result.json());
        renderCart(cart);
        if (error) error.hidden = true;
        openDrawer();
      } catch (exception) {
        if (error) { error.textContent = exception.message; error.hidden = false; }
      } finally {
        if (submit) submit.disabled = false;
      }
    }));
  }
})();
